import TextField from "@mui/material/TextField";
import classes from "./custom-input.module.css";

function CustomInput(props) {
  const {
    placeholder,
    value,
    onChange,
    errorMessage,
    fieldClass,
    name,
    labelName,
    autoComplete,
    inputMode,
  } = props;

  let style = { style: { textAlign: "center", fontSize: "1.2rem" } };

  if (fieldClass === "numberInput") {
    style = { style: { textAlign: "center", fontSize: "1.6rem" } };
  }

  // Browser autofill hints (one-tap fill on mobile); harmless when absent.
  if (autoComplete) style.autoComplete = autoComplete;
  if (inputMode) style.inputMode = inputMode;

  return (
    <TextField
      name={name}
      className={classes[fieldClass]}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      error={errorMessage.length > 0}
      helpertext={errorMessage}
      label={labelName}
      inputProps={style}
      sx={{
        "& .MuiInputBase-input": {
          display: "flex",
          alignItems: "center",
          height: "100%", // Ensures full height alignment
          boxSizing: "border-box", // Prevents layout shifts
        },
      }}
    />
  );
}

export default CustomInput;
